/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const DeleteExternalUserDefaultBudgetQueryParamOwner = {
  Cluster: "cluster",
  Org: "org",
} as const;
export type DeleteExternalUserDefaultBudgetQueryParamOwner = ClosedEnum<
  typeof DeleteExternalUserDefaultBudgetQueryParamOwner
>;

export type DeleteExternalUserDefaultBudgetRequest = {
  owner: DeleteExternalUserDefaultBudgetQueryParamOwner;
  orgId?: string | undefined;
};

export const DeleteExternalUserDefaultBudgetScope = {
  Org: "org",
  Apikey: "apikey",
  User: "user",
  Team: "team",
  ExternalUser: "external_user",
  UserDefault: "user_default",
  TeamDefault: "team_default",
  ExternalUserDefault: "external_user_default",
} as const;
export type DeleteExternalUserDefaultBudgetScope = ClosedEnum<
  typeof DeleteExternalUserDefaultBudgetScope
>;

export const DeleteExternalUserDefaultBudgetOwner = {
  Cluster: "cluster",
  Org: "org",
} as const;
export type DeleteExternalUserDefaultBudgetOwner = ClosedEnum<
  typeof DeleteExternalUserDefaultBudgetOwner
>;

/**
 * OK
 */
export type DeleteExternalUserDefaultBudgetResponseBody = {
  scope: DeleteExternalUserDefaultBudgetScope;
  scopeId: string;
  owner: DeleteExternalUserDefaultBudgetOwner;
  deleted: true;
};

/** @internal */
export const DeleteExternalUserDefaultBudgetQueryParamOwner$inboundSchema:
  z.ZodNativeEnum<typeof DeleteExternalUserDefaultBudgetQueryParamOwner> = z
    .nativeEnum(DeleteExternalUserDefaultBudgetQueryParamOwner);
/** @internal */
export const DeleteExternalUserDefaultBudgetQueryParamOwner$outboundSchema:
  z.ZodNativeEnum<typeof DeleteExternalUserDefaultBudgetQueryParamOwner> =
    DeleteExternalUserDefaultBudgetQueryParamOwner$inboundSchema;

/** @internal */
export const DeleteExternalUserDefaultBudgetRequest$inboundSchema: z.ZodType<
  DeleteExternalUserDefaultBudgetRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  owner: DeleteExternalUserDefaultBudgetQueryParamOwner$inboundSchema,
  org_id: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "org_id": "orgId",
  });
});
/** @internal */
export type DeleteExternalUserDefaultBudgetRequest$Outbound = {
  owner: string;
  org_id?: string | undefined;
};

/** @internal */
export const DeleteExternalUserDefaultBudgetRequest$outboundSchema: z.ZodType<
  DeleteExternalUserDefaultBudgetRequest$Outbound,
  z.ZodTypeDef,
  DeleteExternalUserDefaultBudgetRequest
> = z.object({
  owner: DeleteExternalUserDefaultBudgetQueryParamOwner$outboundSchema,
  orgId: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    orgId: "org_id",
  });
});

export function deleteExternalUserDefaultBudgetRequestToJSON(
  deleteExternalUserDefaultBudgetRequest:
    DeleteExternalUserDefaultBudgetRequest,
): string {
  return JSON.stringify(
    DeleteExternalUserDefaultBudgetRequest$outboundSchema.parse(
      deleteExternalUserDefaultBudgetRequest,
    ),
  );
}
export function deleteExternalUserDefaultBudgetRequestFromJSON(
  jsonString: string,
): SafeParseResult<DeleteExternalUserDefaultBudgetRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      DeleteExternalUserDefaultBudgetRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DeleteExternalUserDefaultBudgetRequest' from JSON`,
  );
}

/** @internal */
export const DeleteExternalUserDefaultBudgetScope$inboundSchema:
  z.ZodNativeEnum<typeof DeleteExternalUserDefaultBudgetScope> = z.nativeEnum(
    DeleteExternalUserDefaultBudgetScope,
  );
/** @internal */
export const DeleteExternalUserDefaultBudgetScope$outboundSchema:
  z.ZodNativeEnum<typeof DeleteExternalUserDefaultBudgetScope> =
    DeleteExternalUserDefaultBudgetScope$inboundSchema;

/** @internal */
export const DeleteExternalUserDefaultBudgetOwner$inboundSchema:
  z.ZodNativeEnum<typeof DeleteExternalUserDefaultBudgetOwner> = z.nativeEnum(
    DeleteExternalUserDefaultBudgetOwner,
  );
/** @internal */
export const DeleteExternalUserDefaultBudgetOwner$outboundSchema:
  z.ZodNativeEnum<typeof DeleteExternalUserDefaultBudgetOwner> =
    DeleteExternalUserDefaultBudgetOwner$inboundSchema;

/** @internal */
export const DeleteExternalUserDefaultBudgetResponseBody$inboundSchema:
  z.ZodType<
    DeleteExternalUserDefaultBudgetResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    scope: DeleteExternalUserDefaultBudgetScope$inboundSchema,
    scope_id: z.string(),
    owner: DeleteExternalUserDefaultBudgetOwner$inboundSchema,
    deleted: z.literal(true),
  }).transform((v) => {
    return remap$(v, {
      "scope_id": "scopeId",
    });
  });
/** @internal */
export type DeleteExternalUserDefaultBudgetResponseBody$Outbound = {
  scope: string;
  scope_id: string;
  owner: string;
  deleted: true;
};

/** @internal */
export const DeleteExternalUserDefaultBudgetResponseBody$outboundSchema:
  z.ZodType<
    DeleteExternalUserDefaultBudgetResponseBody$Outbound,
    z.ZodTypeDef,
    DeleteExternalUserDefaultBudgetResponseBody
  > = z.object({
    scope: DeleteExternalUserDefaultBudgetScope$outboundSchema,
    scopeId: z.string(),
    owner: DeleteExternalUserDefaultBudgetOwner$outboundSchema,
    deleted: z.literal(true),
  }).transform((v) => {
    return remap$(v, {
      scopeId: "scope_id",
    });
  });

export function deleteExternalUserDefaultBudgetResponseBodyToJSON(
  deleteExternalUserDefaultBudgetResponseBody:
    DeleteExternalUserDefaultBudgetResponseBody,
): string {
  return JSON.stringify(
    DeleteExternalUserDefaultBudgetResponseBody$outboundSchema.parse(
      deleteExternalUserDefaultBudgetResponseBody,
    ),
  );
}
export function deleteExternalUserDefaultBudgetResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<
  DeleteExternalUserDefaultBudgetResponseBody,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      DeleteExternalUserDefaultBudgetResponseBody$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'DeleteExternalUserDefaultBudgetResponseBody' from JSON`,
  );
}
